export enum YahootieStatusEnum {
  Correct = 'correct',
  InCorrect = 'Incorrect',
  UnAnswered = 'Unanswered'
}
